import { NetworkStatus } from '@cbridge-utils/network';
import type { ISpreadProfileStore } from './spreadProfile.interface';

export const spreadProfileInitialState: ISpreadProfileStore = {
  data: {},
  networkStatus: NetworkStatus.Done,
};
